import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import '../../styles/modalUE.css';
import { Button } from '@material-ui/core';
import { AlertTriangle, LetterX } from 'tabler-icons-react';
import TextField from '@material-ui/core/TextField';

function getModalStyle() {
    return {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '90%',
        maxWidth: '760px',
        minWidth: '320px',
        height: 'fit-content',
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
        },
    },
}));

export default function ModalUE() {
    const { setOpenUE, openUE, infoUE, setDifCajas, setOpenC } = useGeneral();
    const classes = useStyles();
    const [cajas, setCajas] = useState(0);
    const [flagE, setFlagE] = useState(false);
    const [producido, setProducido] = useState(0);
    const [producidoPaq, setProducidoPaq] = useState(0);

    const [modalStyle] = useState(getModalStyle);

    const handleCloseAll = () => setOpenUE(false);
    const handleClose = () => setOpenUE(false);

    const handleChangeCajas = (event) => {
        const val = event.target.value;

        if (val === '') {
            setCajas('');
            setFlagE(true);
            return;
        }

        const numVal = Number(val);
        setCajas(val);

        if (numVal >= 1 && numVal <= infoUE.paquetesPorTarima) {
            setFlagE(false);
            const difCajas = infoUE.paquetesPorTarima - numVal;
            setProducidoPaq(infoUE.producidoPaq - difCajas);
            setProducido(infoUE.producido - difCajas * infoUE.piezasPorPaquete);
        } else {
            setFlagE(true);
        }
    };

    useEffect(() => {
        setCajas(infoUE.paquetesPorTarima);
        setProducido(infoUE.producido);
        setProducidoPaq(infoUE.producidoPaq);
        setFlagE(false);
    }, [infoUE]);

    const belowMeta = infoUE.metaPaq > infoUE.producidoPaq;

    const body = (
        <div style={modalStyle} className={`${classes.paper} modal-appear-animated`}>
            <div className="modalConf-head" style={{ backgroundColor: '#FE424D' }}>
                <div className="modalConf-text" style={{ color: '#fff' }}>
                    <h4 className="modalConf-text-field">Finalizar Corrida</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>

            <div className="modalUE-body-text">
                <h1 className="modalUE-title">
                    Por favor verifique la cantidad de cajas de la última estiba
                </h1>

                <div className="modalUE-info-row">
                    <div className="modalUE-info-col modalUE-info-col--producto">
                        <h3>Producto:</h3>
                        <h4>{infoUE.nombre}</h4>
                        <h5>{infoUE.sku}</h5>
                    </div>
                    <div className="modalUE-info-col modalUE-info-col--orden">
                        <h3>Orden:</h3>
                        <h4>{infoUE.ordenProd}</h4>
                    </div>
                    <div className="modalUE-info-col modalUE-info-col--cajas">
                        <h3>Cajas por estiba:</h3>
                        <h4>{infoUE.paquetesPorTarima}</h4>
                    </div>
                </div>

                <div className="modalUE-estiba-row">
                    <h2>Última estiba:</h2>
                    <TextField
                        id="outlined-number"
                        label={`Cajas (máx. ${infoUE.paquetesPorTarima})`}
                        type="number"
                        InputProps={{ inputProps: { min: 1, max: infoUE.paquetesPorTarima } }}
                        value={cajas}
                        error={flagE}
                        onChange={handleChangeCajas}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        className="modalUE-cajas-field"
                    />
                </div>

                <div className="modalUE-stats-row">
                    <div className="modalUE-stat-col">
                        <div className="modalUE-stat-values">
                            <h3>Meta:</h3>
                            <h4>{infoUE.metaPaq}</h4>
                            <h5>Cajas</h5>
                        </div>
                        <div className="modalUE-stat-values">
                            <h4>{infoUE.meta}</h4>
                            <h5>Piezas</h5>
                        </div>
                    </div>
                    <div className="modalUE-stat-col">
                        <div className="modalUE-stat-values">
                            <h3>Producido:</h3>
                            <h4>{producidoPaq}</h4>
                            <h5>Cajas</h5>
                        </div>
                        <div className="modalUE-stat-values">
                            <h4>{producido}</h4>
                            <h5>Piezas</h5>
                        </div>
                    </div>
                </div>

                {belowMeta && (
                    <div className="modalUE-warning">
                        <AlertTriangle size={28} color={'#eed202'} />
                        <h4>Va a cerrar una corrida antes de cumplir la meta.</h4>
                    </div>
                )}

                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS"
                            style={{ backgroundColor: flagE ? '#eaeaea' : '#FE424D' }}
                            disabled={flagE}
                            onClick={() => {
                                handleClose();
                                setDifCajas(Number(cajas) - infoUE.paquetesPorTarima);
                                setOpenC(true);
                            }}
                        >
                            <h1 style={{ color: flagE ? '#c0c0c0' : '#fff' }}>Confirmar</h1>
                        </Button>
                    </div>
                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC"
                            style={{
                                borderRadius: '3px',
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderColor: '#FE424D',
                            }}
                            onClick={handleClose}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <Modal
            open={openUE}
            onClose={handleClose}
            aria-labelledby="modal-finalizar-corrida"
        >
            {body}
        </Modal>
    );
}
